import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import globals from 'scoreboard/components/globals'
import calendars from 'scoreboard/components/calendars'
import permissions from 'scoreboard/components/permissions'
import user from 'scoreboard/components/user'
import cloneDeepWithDatasetShallow from '../../datasets/clone-deep-with-dataset-shallow'

let BaseReportModel = Backbone.Model.extend({

	section: 'reports',
	domainType: 'report',

	urlRoot: function(path, params) {
		var query = params ? '?' + $.param(params) : ''
		return 'api/reports/'+ (path || '') + query
	},

	initialize(attrs, opts = {}) {
		this.options = opts
		if (this.observableProperties) {
			let events = _.join(_.map(this.observableProperties, val => `change:${val}`), ' ')
			this.on(events, () => {
				this.set({ 'dirty': true }, { silent: true })
				this.stale = true
			})
		}
		this.on('sync', () => {
			this.set({ 'dirty': false })
			this.cancelAttributes = cloneDeepWithDatasetShallow(this.attributes)
		})
		this.on('change', () => {
			if (!this.cancelAttributes) {
				//ensure we can cancel without saving first
				this.cancelAttributes = this.previousAttributes()
			}
		})
	},

	periodParams: function(params = {}) {
		return _.assign({
			relativePeriodId: globals.periodId,
			currentCalendarId: calendars.periodsById[globals.periodId].calendar.id
		}, params)
	},

	stream: function(stream) {
		if (arguments.length == 0) { return this.results }
		this.results = stream
	},

	/**
	 * Applies the given sort settings to the model.
	 *
	 * @param {Object} sort
	 *
	 * @param {String} sort.sortField the column to use for sorting
	 *
	 * @param {Boolean} sort.ascending true if the values should ascend, false
	 * if they should descend
	 *
	 * @param {Integer} sort.sortPeriodIndex in a multi-period report, this is
	 * the index of the period column that should be used for sorting
	 */
	setSort: function (sort) {
		if (!sort) {
			return
		}

		let columns = _.get(this.get('columns'), 'columns')
		if (!columns) {
			return
		}

		// #24709 only apply the sort if the column actually exists
		if (!_.includes(columns, sort.sortField)) {
			return
		}

		this.set(sort)
	},

	isEditable: function() {
		//#9287 if you can view the report and not a strict viewer then you can
		//edit it, you just may not be able to save it
		return !user.isStrictViewer() && permissions.isEditableIfReplicated(this)
	},

	cloneAsNew () {
		let model = new this.constructor(cloneDeepWithDatasetShallow(this.attributes))

		// #11481 don't carry over the report model reference data id
		_.each(['id', 'subtypeId'], function(v) {
			model.unset(v, {silent:true})
		})
		if (model.get('chart')) {
			model.get('chart').unset('id')
		}
		// #17990 null out all filter ids so new ones are created
		let filterChain = _(model.get('filters'))
		if (this.reportDomainType != 'dataset') {
			filterChain.flatMap(filters => _.values(filters))
		}
		filterChain.each(f => delete f.id)
		return model
	},

	formatErrors(err, options = {}) {
		if (_.isEmpty(err)) return null
		if (options.formView) {
			if (_.isArray(err)) {
				return _.get(err[0], 'label', err[0])
			}
			return _.get(err, 'label', err)
		}
		return options.messageList ? _.values(err) : err
	},

	_setMetadata: function(metadata) {
		this.metadata = metadata
		this.trigger('metadata', metadata)
	},

	showPeriodSelector: function() {
		return !!this.periodSelector
	}

})

export default BaseReportModel

BaseReportModel.__filename__ = 'reports/common/base-report-model.js'
